import {
  FileCheck2,
  GraduationCap,
  Handshake,
  ShieldCheck,
  Users
} from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { aboutPageData } from "../../data/aboutData";

const icons = [GraduationCap, Users, FileCheck2, ShieldCheck, Handshake];

function AboutSupportSystem() {
  const { supportSystem } = aboutPageData;

  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="How We Support"
          title="A Complete Guidance System Around You"
          description="From first consultation to final documentation confidence, your journey is supported by specialists at every critical stage."
        />

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {supportSystem.map((item, index) => {
            const Icon = icons[index % icons.length];

            return (
              <article
                key={item.role}
                className="group signature-card signature-card-interactive rounded-2xl p-6"
              >
                <div className="flex items-center justify-between">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-sky-glow text-royal-blue">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <span className="text-xs font-semibold tracking-[0.14em] text-slate-text/50">
                    {`STEP ${index + 1}`}
                  </span>
                </div>
                <h3 className="mt-4 text-xl leading-tight">{item.role}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-text/80">{item.text}</p>
              </article>
            );
          })}
        </div>
      </div>
    </MotionSection>
  );
}

export default AboutSupportSystem;
